// extracted by mini-css-extract-plugin
module.exports = {"holder":"holder--CE479"};